import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '~common/service/authentication.service'

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  userProfile: any;
  constructor(private router: Router, private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.userProfile = this.authService.getProfile();
  }

  back() {
    if(Object.keys(this.userProfile).length > 0){
      if(this.userProfile.isAdmin){
        this.router.navigate(['/admin']);

      }else{
        this.router.navigate(['/']);
      }
    }else{
      this.router.navigate(['/login']);
    }
  }
}
